import React from 'react';

const ScrollDown = () => (
  <p className="scrolldown">
    <a className="smoothscroll" href="#about">
      <i className="icon-down-circle"/>
    </a>
  </p>
);

export default ScrollDown;


// WEBPACK FOOTER //
// ./src/components/Header/ScrollDown.js